//
// IMPORTS
//

// Vue
import Vue from 'vue'

// Third-party
import Vuetify from 'vuetify/lib/framework'
import VueHead from 'vue-head'
import VueTheMask from 'vue-the-mask'

// App
import App from './App.vue'

// Router
import router from './router'

// Store
import store from './store'

// Firebase settings
import { firebaseSettingsObject, version } from './constants'

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
// import * as firebase from 'firebase/app'

//
// PLUGINS
//

// VUETIFY
Vue.use(Vuetify)
// VUE HEAD
Vue.use(VueHead)
// VUE THE MASK
Vue.use(VueTheMask)
// VUETIFY THEME CONFIGURATION SETTINGS
const theme = { primary: '#e54245', secondary: '#3e3e3e', accent: '#666666', info: '#00CAE3' }
const vuetify = new Vuetify({ theme: { themes: { dark: theme, light: theme } } })

//
// Inicializa VUE
//

Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.config.debug = process.env.NODE_ENV !== 'production'
Vue.config.silent = process.env.NODE_ENV === 'production'
Vue.config.productionTip = true

console.log('::: [DEBUG] Vue.config.devtools:', Vue.config.devtools)
console.log('::: [DEBUG] Vue.config.debug:', Vue.config.debug)
console.log('::: [DEBUG] Vue.config.silent:', Vue.config.silent)
console.log('::: [DEBUG] Vue.config.productionTip:', Vue.config.productionTip)

console.log('::::::::::::::::::::::::::::::::::::::::::')
console.log('::: BUILD VERSION:', version || 'UNKNOWN')
console.log('::::::::::::::::::::::::::::::::::::::::::')

//
// Inicializa FIREBASE
//

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseSettingsObject)
}

//
// Acompanha mudanças na sessão do FIREBASE
//

let $viewApp = null

firebase.auth().onAuthStateChanged(user => {
  const authenticated = !!user === true && !!user.email === true && !!user.uid === true

  store.dispatch('setAuthState', {
    sosOrigin: 'STATE',
    authenticated,
    uid: authenticated ? user.uid : '',
    email: authenticated ? user.email : '',
    token: '',
    user,
  })

  if (!!$viewApp === false)
  {
    /* eslint-disable no-new */
    $viewApp = new Vue({
      router,
      store,
      vuetify,
      VueTheMask,
      VueHead,
      render: h => h(App),
    }).$mount('#app')
  }
})
